<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/statistics/outproduce/list'

export default {
  name: "outproduce",
  mixins: [curdMixins],
  components: { list },
  methods: {
    
  }
};
</script>